import React from "react";
import { Link } from "react-router-dom";
import './Home.css';

function Home() {
    return (
      
      <div className="container mx-auto p-4">
       <div id="homeScreen" class="horizon">
      <div id="spaceVoid" className="laser-container"></div>
      <div id="laserGrid" className="laser-container">
        <div id="axis">
          <div id="verticalLines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <div id="horizontalLines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="polaroid retro">
          <img src="/alert.png" />
  
          <p>Joan With the Code</p>
        </div>
      </div>
      <h2 id="enterBtn" class="btn"> <Link
                           to={`/About`} 
                           className="sm:w-1/2 w-100 p-4"
                         >Enter</Link></h2>
      <h3></h3>
    </div>
        
      </div>
    );
  }
  
  export default Home;